import React, { useState } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { navLinks } from '../data/mockData';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      {/* Top Banner */}
        <div className="bg-gray-900 text-white py-2 px-2 sm:px-4 text-center text-xs sm:text-sm">
          <span className="mr-1 sm:mr-2">🚀</span>
          <span className="hidden xs:inline">Revolutionize your chatbot management with waatee </span>
          <span className="xs:hidden">Try waatee today </span>
          <a href="https://app.waatee.com/register" className="inline-flex items-center bg-[#25D366] text-white px-2 sm:px-3 py-0.5 rounded-full text-xs font-medium ml-1 sm:ml-2 hover:bg-[#1da851] transition-colors">
            Explore
          </a>
        </div>

      {/* Main Navbar */}
        <nav className="bg-white border-b border-gray-100 sticky top-0 z-50">
          <div className="max-w-7xl mx-auto px-2 sm:px-4 md:px-6 lg:px-8">
            <div className="flex items-center justify-between h-14 sm:h-16">
            {/* Logo */}
              <a href="/" className="flex items-center flex-shrink-0">
                <img 
                  src="https://customer-assets.emergentagent.com/job_waatee-replica/artifacts/h7boywtn_image.png" 
                  alt="waatee" 
                  className="h-8 sm:h-10 w-auto"
                />
            </a>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center gap-8">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-gray-700 hover:text-gray-900 transition-colors text-sm font-medium flex items-center gap-1"
                >
                  {link.name}
                </a>
              ))}
            </div>

            {/* Desktop CTA */}
            <div className="hidden md:flex items-center gap-3">
              <a 
                href="https://app.waatee.com/login" 
                className="text-gray-700 hover:text-gray-900 transition-colors text-sm font-medium px-4 py-2"
              >
                Login
              </a>
              <a 
                href="https://app.waatee.com/register" 
                className="text-gray-700 hover:text-gray-900 transition-colors text-sm font-medium px-4 py-2 border border-gray-200 rounded-full hover:border-gray-300"
              >
                Book a Demo
              </a>
              <a
                href="https://app.waatee.com/register"
                className="bg-[#25D366] text-white px-5 py-2 rounded-full text-sm font-medium hover:bg-[#1da851] transition-colors border-2 border-[#25D366] hover:border-[#1da851]"
              >
                Try for Free
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden p-2"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 p-4">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-gray-700 hover:text-gray-900 transition-colors text-sm font-medium py-2"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.name}
                </a>
              ))}
              <hr className="my-2" />
              <a href="https://app.waatee.com/login" className="text-gray-700 hover:text-gray-900 transition-colors text-sm font-medium py-2">
                Login
              </a>
              <a href="https://app.waatee.com/register" className="text-gray-700 hover:text-gray-900 transition-colors text-sm font-medium py-2">
                Book a Demo
              </a>
              <a
                href="https://app.waatee.com/register"
                className="bg-[#25D366] text-white px-5 py-2.5 rounded-full text-sm font-medium hover:bg-[#1da851] transition-colors text-center"
              >
                Try for Free
              </a>
            </div>
          </div>
        )}
      </nav>
    </>
  );
};

export default Navbar;
